import React from 'react'
import Contact from '../components/Contact'
import './contact.css'

class ContactPage extends React.Component {
  constructor () {
    super()
    this.state = {}
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleEmailChange = this.handleEmailChange.bind(this)
    this.handleMessageChange = this.handleMessageChange.bind(this)
  }

  handleSubmit (event) {
    event.preventDefault()
    if (!event.target.checkValidity()) {
      this.setState({ displayErrors: true })
      return
    }

    var formData = new FormData()
    formData.append('_email', this.state.email)
    formData.append('_message', this.state.message)
    this.setState({ isSentSuccessfully: true })

    fetch('https://api.codehacker.se/mail.php', {
      method: 'POST',
      body: formData
    })
      .catch(error => console.error(`Fetch Error =\n`, error))
  }

  handleEmailChange (e) {
    this.setState({email: e.target.value})
  }

  handleMessageChange (e) {
    this.setState({message: e.target.value})
  }

  render () {
    const { displayErrors } = this.state
    return <Contact />
    // if (this.state.isSentSuccessfully) {
    //   return (
    //     <Contact>
    //       <h2 className='mt-5'>Thank you for your message!</h2>
    //     </Contact>
    //   )
    // }

    // return (
    //   <Contact>
    //     <form onSubmit={this.handleSubmit} noValidate className={displayErrors ? 'mt-5 displayErrors' : 'mt-5'}>

    //       <div className='form-group'>
    //         <label htmlFor='emailAddress'>Email address</label>
    //         <input type='email' className='form-control' id='emailAddress' aria-describedby='emailHelp' placeholder='Enter email' required value={this.state.email || ''} onChange={this.handleEmailChange} />
    //         <small id='emailHelp' className='form-text text-muted'>We'll never share your email with anyone else.</small>
    //       </div>

    //       <div className='form-group'>
    //         <label htmlFor='messageBox'>Your message</label>
    //         <textarea className='form-control' id='messageBox' rows='5' required value={this.state.message || ''} onChange={this.handleMessageChange} />
    //       </div>
    //       <button type='submit' className='btn btn-primary'>Submit</button>
    //     </form>
    //   </Contact>
    // )
  }
}

export default ContactPage



// WEBPACK FOOTER //
// ./src/pages/contact.js